import { render } from "./FormatCurrency.vue?vue&type=template&id=1488c366"
import script from "./FormatCurrency.vue?vue&type=script&lang=js"
export * from "./FormatCurrency.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__